import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import { Icon, Button } from 'loyal-react'
import { Form } from './Form'
import { ShippingCalculed } from './ShippingCalculed'
import yn from 'yn'

class ShippingCalculator extends Component {
  state = { zipCode: '', wasCalculed: false }

  componentDidMount () {
    if (this.props.zipCodeValue) {
      this.calculate(true)
    }
  }

  handleZipCodeChange = event => {
    this.setState({ zipCode: event.target.value })
  }

  calculate = zipCodeMemory => {
    const zipCodeWithoutFormat = zipCodeMemory
      ? this.props.zipCodeValue
      : this.state.zipCode

    this.props.fetchShipping(zipCodeWithoutFormat.replace('-', ''))
    this.setState({ wasCalculed: true })
  }

  handleUpdateAddress = shippingAddress => {
    this.props.updateShippingAddress(
      this.createRequest({
        shippingAddress
      })
    )
  }

  isZipCodeValid = value => !!value && value.length === 8

  validateZipCode = () => {
    const { number, value } = this.state.zipCode
    const isValid = this.isZipCodeValid(number)
    const zipCode = { value, number, isValid }
    this.setState({ zipCode, dirty: true })
  }
  createRequest = shipping => {
    return {
      customer: {
        name: this.props.participant.name.value,
        documentNumber: this.props.participant.cpf.value,
        email: this.props.participant.email.value,
        birthDate: this.props.participant.birthDate.value,
        genderType:
          this.props.participant.genderType.value === 1 ? 'MALE' : 'FEMALE',
        personType: this.props.participant.personType,
        phones: this.props.participant.phones
      },
      shippingAddress: {
        street: this.props.address.street,
        number: '',
        complement: '',
        district: this.props.address.district,
        city: this.props.address.city,
        state: this.props.address.state,
        zipCode: this.props.address.zipCode,
        reference: ''
      }
    }
  }

  edit = () => {
    this.props.resetShipping()
    this.setState({ wasCalculed: false })
  }
  editCEP = (isLoading) => {
    this.edit()
    !isLoading && setTimeout(() => {
      document.querySelector(`#zipCode`).focus()
    }, 300)
  }
  render () {
    const isLoading =
      this.props.shipping.isLoading || this.props.address.isLoading

    const zipCode = this.props.participant.address.zipCode.disabled
      ? !this.props.shipping.fetchShipping &&
        this.props.participant.address.zipCode.value !== ''
        ? this.props.participant.address.zipCode.value
        : ''
      : this.props.shipping.fetchShipping && this.props.address.zipCode === ''
        ? this.props.participant.address.zipCode.value
        : this.props.address.zipCode

    if (
      !this.props.address.isLoading &&
      zipCode !== '' &&
      this.props.shipping.fetchShipping
    ) {
      if (!yn(process.env.REACT_APP_FIX_CART_ERROR)) {
        this.handleUpdateAddress(zipCode)
      }
    }

    const props = {
      ...this.props,
      zipCode: this.state.zipCode,
      handleZipCodeChange: this.handleZipCodeChange,
      calculate: this.calculate,
      edit: this.edit,
      isLoading
    }

    const showShippingCalculed = this.state.wasCalculed

    return (
      <div className='container-cart-shipping row px-1 px-md-3 bg-ui-5 border-color-ui-3 border-bottom py-2'>
        <div className='cart-shipping h-auto col-12 px-0'>
          <div className='row mx-0 align-items-center h-100'>
            <div className='col-auto'>
              <Icon iconName='icon_truck' className='color-brand-4 icon' />
            </div>
            <div className='shipping-title'>
              <span className='txt-uppercase txt-circular-black txt-body txt-left' aria-label='Frete e endereço de entrega'>
                Frete e endereço de entrega
              </span>
            </div>
            {showShippingCalculed ? (
              <div className='change-zipcode col-8'>
                <ShippingCalculed
                  {...props}
                  decimalPlaces={props.decimalPlaces}
                />
                <a href='javascript:void(0)' onClick={() => showShippingCalculed ? this.editCEP(props.isLoading) : (!showShippingCalculed && !props.zipCode ? false : this.calculate(false))}>Alterar endereço</a>
              </div>
            ) : (
              <Form {...props} />
            )}

            {!this.props.participant.address.zipCode.disabled ? (
              ''
            ) : (
              (showShippingCalculed ? (
                ''
              ) : (
                <Fragment>
                  <div className='content-shipping-zipcode-sheach'>
                    <div className='calculate-shipping-zipcode d-flex'>
                      <Button
                        id='buttonFetchShipping'
                        className='button-shipping'
                        onClick={() => showShippingCalculed ? this.editCEP(props.isLoading) : (!showShippingCalculed && !props.zipCode ? false : this.calculate(false))}
                        text='OK'
                      />
                    </div>
                  </div>
                  <div className='search-zipcode'>
                    <a href='https://buscacepinter.correios.com.br/app/cep/index.php' target='_blank'>Procurar CEP</a>
                  </div>
                </Fragment>
              ))
            )
            }
          </div>
        </div>
      </div>
    )
  }
}

ShippingCalculator.propTypes = {
  address: PropTypes.object.isRequired,
  shipping: PropTypes.object.isRequired,
  fetchShipping: PropTypes.func.isRequired,
  resetShipping: PropTypes.func.isRequired,
  handleUpdateAddress: PropTypes.func.isRequired,
  shippingAddress: PropTypes.object,
  isUpdatingShippingAddressToCart: PropTypes.bool,
  updateShippingAddress: PropTypes.func.isRequired,
  createRequest: PropTypes.func.isRequired,
  participant: PropTypes.object,
  zipCodeValue: PropTypes.any,
  decimalPlaces: PropTypes.number
}

export default ShippingCalculator



// WEBPACK FOOTER //
// ./src/features/Cart/List/ShippingCalculator/ShippingCalculator.js